module.exports = __webpack_public_path__ + "assets/img/1.d430aa91.png";